module.exports = __webpack_public_path__ + "img/ic_first_page.012db081.svg";